import React from "react";
import "./Contact.css";

export default function Contact() {
  return (
    <div className="contactContainer">
      <div className="contact-header slide-in-right">
        <h3>start the dialogue..</h3>
      </div>
      <div className="logo-container">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://github.com/darnycya"
        >
          <img
            className="logo-contacts"
            alt="github"
            src="https://img.icons8.com/?size=512&id=63777&format=png"
          />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="mailto:darnycya@gmail.com"
        >
          <img
            className="logo-contacts"
            alt="email"
            src="https://img.icons8.com/?size=512&id=qyRpAggnV0zH&format=png"
          />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://medium.com/@darnycya"
        >
          <img
            className="logo-contacts"
            alt="medium"
            src="https://img.icons8.com/?size=512&id=m8ClhVaNuUH7&format=png"
          />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/darnycya/"
        >
          <img
            className="logo-contacts"
            alt="linkedin"
            src="https://img.icons8.com/?size=512&id=13930&format=png"
          />
        </a>
      </div>
      <div className="footer-trademark">
        <p>© 2026 darnycya. all rights reserved.</p>
        </div>
    </div>
  );
}
